export class NavbarItems {
  text: string;
  id?: string;
  icon?: string;
  expanded?: boolean;
  items?: NavbarItems[];
  path?: string;
}

export const navbarItems: NavbarItems[] = [
  //LJUDSKI RESURSI
  {
    text: 'Ljudski resursi',
    id: 'ljudski-resursi',
    icon: 'user',
    expanded: false,
    items: [
      {
        text: 'Raspored ljudi',
        path: '/raspored-ljudi',
        icon: 'sortdowntext',
      },

      {
        text: 'Djelatnici',
        path: '/djelatnici',
        icon: 'group',
      },

      {
        text: 'Godišnji odmori',
        path: '/godisnji-odmori',
        icon: 'airplane',
      },

      {
        text: 'Izostanci 1',
        path: '/izostanci',
        icon: 'remove',
      },

      {
        text: 'Izostanci 2 (bolovanja)',
        path: '/bolovanja',
        icon: 'remove',
      },

      {
        text: 'Dežurstvo',
        path: '/dezurstvo',
        icon: 'event',
      },

      {
        text: 'Prijave/odjave djelatnika',
        path: '/prijave-odjave-djelatnika',
        icon: 'info',
      },

      {
        text: 'Digitalna ploča',
        path: '/digitalna_ploca',
        icon: 'paste',
      },

      {
        text: 'Uređaji',
        path: '/uredjaji',
        icon: 'card',
      },
    ],
  },

  {
    //PROIZVODNJA
    text: 'Proizvodnja',
    id: 'proizvodnja',
    icon: 'product',
    expanded: false,
    items: [
      {
        text: 'Nadzorna ploča',
        path: '/nadzorna-ploca',
        icon: 'home',
      },

      {
        text: 'Plan proizvodnje po danima',
        path: '/dnevni-plan',
        icon: 'clock',
      },

      {
        text: 'Plan proizvodnje po linijama',
        path: '/plan-proizvodnje',
        icon: 'event',
      },

      {
        text: 'Dnevni izvještaj završenih RN',
        path: '/izvjestaj-zavrsenih-rn',
        icon: 'comment',
      },

      {
        text: 'Radni nalozi - dokumenti',
        path: '/radni-nalozi-dokumenti',
        icon: 'folder',
      },

      {
        text: 'Kapacitet linija',
        path: '/kapacitet-linija',
        icon: 'greaterorequal',
      },

      {
        text: 'Proizvod: procesi',
        path: '/procesi',
        icon: 'link',
      },

      {
        text: 'Šifarnik: procesi',
        path: '/sifarnik-procesi',
        icon: 'variable',
      },

      {
        text: 'Šifarnik: proizvodi/sirovine',
        path: '/sifarnik-proizvodi',
        icon: 'variable',
      },

      {
        text: 'Linija: strojevi',
        path: '/strojevi',
        icon: 'box',
      },

      {
        text: 'Ostvareni sati',
        path: '/ostvareni-sati',
        icon: 'clock',
      },

      {
        text: 'Napravljeni dokumenti',
        path: '/dokumenti',
        icon: 'doc',
      },
    ],
  },

  //SKLADIŠTE
  {
    text: 'Skladište',
    id: 'skladiste',
    icon: 'toolbox',
    expanded: false,
    items: [
      // Stanje skladišta - new
      {
        text: 'Stanje skladišta',
        path: '/stanje-skladista',
        icon: 'contentlayout',
      },

      {
        text: 'Ispis plana',
        path: '/ispis-plana',
        icon: 'print',
      },

      {
        text: 'Pregled izdatnica',
        path: '/pregled-izdatnice',
        icon: 'folder',
      },

      {
        text: 'Pregled izdatnica - trošak',
        path: '/pregled-izdatnice-trosak',
        icon: 'folder',
      },

      {
        text: 'Pregled izdatnica - pot. materijal',
        path: '/pregled-izdatnice-potrosni-materijal',
        icon: 'folder',
      },

      {
        text: 'Pregled - revers',
        path: '/pregled-revers',
        icon: 'folder',
      },

      {
        text: 'Pregled zahtjeva za sirovine',
        path: '/pregled-zahtjeva-za-sirovine',
        icon: 'cart',
      },

      {
        text: 'Rekapitulacija izdatnica',
        path: '/izdatnice-sirovina',
        icon: 'product',
      },

      {
        text: 'Rekapitulacija ulaza',
        path: '/ulaz-sirovina',
        icon: 'product',
      },

      {
        text: 'Signalni lager sirovina',
        path: '/signalni-lager-sirovina',
        icon: 'square',
      },

      {
        text: 'Rokovi trajanja',
        path: '/rokovi-trajanja',
        icon: 'paste',
      },

      {
        text: 'Primke',
        path: '/primke',
        icon: 'box',
      },

      {
        text: 'Međuskladišnice',
        path: '/meduskladisnice',
        icon: 'mediumiconslayout',
      },

      {
        text: 'Međuskladišnice za mrvice',
        path: '/meduskladisnice_za_mrvice',
        icon: 'mediumiconslayout',
      },
    ],
  },

  //NALJEPNICE, LOTOVI I STANJA
  {
    text: 'Naljepnice, lotovi, stanja',
    id: 'naljepnice-lotovi-stanja',
    icon: 'cart',
    expanded: false,
    items: [
      {
        text: 'Naljepnice za ispis',
        path: '/naljepnice',
        icon: 'contains',
      },

      {
        text: 'LOT naljepnice',
        path: '/lot-naljepnice',
        icon: 'print',
      },

      {
        text: 'Pregled po lotovima',
        path: '/pregled-lotovi',
        icon: 'orderedlist',
      },

      {
        text: 'Narudžbe',
        path: '/narudzbe',
        icon: 'paste',
      },

      {
        text: 'Dostavnice',
        path: '/dostavnice',
        icon: 'folder',
      },

      {
        text: 'Otpremnice',
        path: '/otpremnice',
        icon: 'folder',
      },

      {
        text: 'Naručene količine',
        path: '/narucene-kolicine',
        icon: 'repeat',
      },

      {
        text: 'Naručene količine po grupi',
        path: '/narucene-kolicine-grupe',
        icon: 'repeat',
      },

      /*
      {
        text: 'Stanje skladišta',
        path: '/skladiste',
        icon: 'contentlayout',
      },
      */

      {
        text: 'Skladište hlad',
        path: '/skladiste-hlad',
        icon: 'contentlayout',
      },
    ],
  },

  //PROIZVODI NA AKCIJI
  {
    text: 'Proizvodi na akciji',
    id: 'proizvodi-na-akciji',
    icon: 'percent',
    expanded: false,
    items: [
      {
        text: 'Svi proizvodi na akciji',
        path: '/proizvodi-akcija',
        icon: 'spinnext',
      },

      // {
      //   text: 'Akcije Boso i NTL',
      //   path: '/akcije-boso-ntl',
      //   icon: 'spinnext',
      // },

      {
        text: 'Akcije Hrvatska',
        path: '/akcije-hrvatska',
        icon: 'spinnext',
      },

      {
        text: 'Akcije inozemstvo',
        path: '/akcije-inozemstvo',
        icon: 'spinnext',
      },

      {
        text: 'Partneri',
        path: '/partneri',
        icon: 'folder',
      },
    ],
  },

  {
    text: 'Ulazne fakture',
    path: '/ufe',
    icon: 'parentfolder',
  },

  {
    text: 'Kartica artikla',
    path: '/kartica_artikla',
    icon: 'floppy',
  },

  {
    text: 'Odjava',
    icon: 'runner',
  },
];

export class NavbarItemsHlad {
  text: string;
  id?: string;
  icon?: string;
  expanded?: boolean;
  items?: NavbarItemsHlad[];
  path?: string;
}

export const navbarItemsHlad: NavbarItemsHlad[] = [
  {
    text: 'Skladište hlad',
    id: 'skladiste-hlad',
    icon: 'home',
    expanded: false,
    items: [
      {
        text: 'Dostavnica hlad',
        path: '/dostavnica-hlad',
        icon: 'increaseindent',
      },

      {
        text: 'Skladište hlad',
        path: '/skladiste-hlad',
        icon: 'contentlayout',
      },

      {
        text: 'Odjava',
        icon: 'runner',
      },
    ],
  },
];
